import styled from '@emotion/styled';
import { shouldForwardProp } from '@trinity/chat-components/utils/emotion';

const baseTextareaPadding = 10;
const submitBtnSize = 38;
const buttonsSpacing = 10;

// Buttons now sit in a bottom row; only the send button (rightmost) needs right clearance.
export const editorPaddingRight = baseTextareaPadding + submitBtnSize + buttonsSpacing;

export const uploadButtonHeight = 40;

type EditorWrapperProps = {
  chrome: 'standalone' | 'embedded';
};

export const EditorWrapper = styled('div', { shouldForwardProp: shouldForwardProp('chrome') })<EditorWrapperProps>(
  ({ chrome, theme }) => ({
  boxSizing: 'border-box',
  position: 'relative',
  backgroundColor: theme.palette.white.main,
  borderRadius: 5,
  border: 'none',
  outline: 'none',
  resize: 'none',
  padding: 0,
  width: '100%',

  fontFamily: theme.fonts.regular,
  fontSize: 16,
  color: theme.palette.black.light1,

  '& .ProseMirror, & .remirror-editor.ProseMirror': {
    outline: 'none',
    // Embedded (side panel) keeps a constant height and scrolls long queries instead of
    // growing, so the message list above never shifts as the user types.
    height: chrome === 'embedded' ? 53 : undefined,
    minHeight: chrome === 'embedded' ? undefined : 53,
    maxHeight: chrome === 'embedded' ? undefined : 390,
    overflowY: 'auto',
    whiteSpace: 'pre-wrap',
    wordBreak: 'break-word',

    [`@media (max-width: ${theme.breakpoints.values.chatCompactLayout}px)`]: {
      height: chrome === 'embedded' ? 40 : undefined,
      minHeight: chrome === 'embedded' ? undefined : 40,
    },

    '& p': {
      margin: 0,
      // Containing block for the placeholder below, so it pins to the first paragraph's
      // top-left rather than to EditorWrapper (which also wraps staged-file content).
      position: 'relative',
    },

    '& .remirror-is-empty:first-of-type::before': {
      content: 'attr(data-placeholder)',
      color: theme.palette.gray.main,
      pointerEvents: 'none',
      position: 'absolute',
      top: 0,
      left: 0,
    },

    '& .remirror-mention-atom': {
      fontFamily: theme.fonts.semiBold,
      color: theme.palette.primary.main,
    },
  },
})
);
